import { motion } from "motion/react";
import styled, { css, keyframes } from "styled-components";

import {
  DATA_E2E_KEY,
  DRAWER_MOTION_ENTER_OPACITY,
  IStyledAttributes,
  RIGHTBAR_DEFAULT_WIDTH_MOBILE,
} from "@ryde/shared";
import { greyMui, MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";

const fadeIn = keyframes`
  from {
    opacity: ${DRAWER_MOTION_ENTER_OPACITY};
  }
  to {
    opacity: 1;
  }
`;

interface IDrawerMotionWrapperStyledProps extends IStyledAttributes {
  $skipCssEnter: boolean;
  $enterDurationSeconds: number;
}

export const DrawerMotionWrapperStyled = styled(
  motion.div,
).attrs<IDrawerMotionWrapperStyledProps>({
  [DATA_E2E_KEY]: "drawer-motion-wrapper-styled",
})<IDrawerMotionWrapperStyledProps>`
  background-color: ${rydeColors.white};
  position: absolute;
  width: ${props => props.custom};
  top: 0;
  bottom: 0;
  inset-inline-end: 0;
  padding: 0;
  border-inline-start: 1px solid ${greyMui._300};
  display: flex;
  flex-direction: column;
  overflow: ${props => (props.$skipCssEnter ? "visible" : "hidden")};

  ${props =>
    props.$skipCssEnter
      ? ""
      : css`
          @media (prefers-reduced-motion: no-preference) {
            animation: ${fadeIn} ${props.$enterDurationSeconds}s ease-out both;
          }
        `}

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: ${RIGHTBAR_DEFAULT_WIDTH_MOBILE};
  }
`;
